import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '@rolefit/shared/react';
import { AppShell } from './components/AppShell.js';
import { LoginPage } from './pages/LoginPage.js';
import { PipelinePage } from './pages/PipelinePage.js';
import { BoardPage } from './pages/BoardPage.js';
import { OutreachPage } from './pages/OutreachPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { OnboardPage } from './pages/OnboardPage.js';

function Loading() {
  return <div className="grid min-h-screen place-items-center text-muted-foreground">Loading…</div>;
}

function Protected({ children }: { children: ReactNode }) {
  return (
    <ProtectedRoute fallback={<Loading />}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/onboard"
        element={
          <ProtectedRoute fallback={<Loading />}>
            <OnboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <Protected>
            <PipelinePage />
          </Protected>
        }
      />
      <Route
        path="/board"
        element={
          <Protected>
            <BoardPage />
          </Protected>
        }
      />
      <Route
        path="/outreach"
        element={
          <Protected>
            <OutreachPage />
          </Protected>
        }
      />
      <Route
        path="/settings"
        element={
          <Protected>
            <SettingsPage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
